export default {
  containers: {
    location_info: 'Informazioni sulla location',
    attributes: 'Attributi',
    links: 'Link',
  },
  labels: {
    title: 'Titolo',
    phone_number: 'Numero di telefono',
    description: 'Descrizione',
    website: 'Sito web',
    address: 'Indirizzo',
    regular_hours: 'Orari regolari',
    page_urls: 'URL pagina',
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',
    twenty_four_hours: '24 ore',
    open_24_hours: 'Aperto 24 ore',
    open_time: 'Orario apertura',
    close_time: 'Orario chiusura',
    url: 'URL',
    provider_type: 'Tipo fornitore',
    provider_types: {
      merchant: 'Esercente',
      aggregator: 'Aggregatore',
    },
    place_action_type: 'Tipo',
    is_preferred: 'Preferito',
    place_action_types: {
      appointment: 'Prenotazione appuntamento',
      online_appointment: 'Prenotazione online',
      dining_reservation: 'Link prenotazioni',
      food_ordering: 'Ordine cibo per consegna e/o asporto',
      food_delivery: 'Link consegna',
      food_takeout: 'Link asporto',
      shop_online: 'Acquisto con consegna e/o ritiro',
    },
    no_links: 'Nessun link disponibile per questa attività',
    url_menu: 'Link menu',
    url_reservations: 'Link prenotazioni',
  },
  placeholders: {
    title: 'Titolo',
    phone_number: 'Numero di telefono',
    description: 'Descrizione',
    website: 'Sito web',
    address: 'Indirizzo',
    regular_hours: 'Orari regolari',
    page_urls: 'URL pagina',
    address_line_1: 'Indirizzo riga 1',
    postal_code: 'CAP',
    locality: 'Località',
    region_code: 'Codice regione',
    language_code: 'Codice lingua',
    select_time: 'Seleziona orario',
    url: 'URL',
  },
  buttons: {
    submit: 'Invia',
    add: 'Aggiungi',
    delete: 'Elimina',
    generate_description: 'Genera descrizione con AI',
  },
  validation: {
    required: 'Campo obbligatorio',
    invalid_url: 'URL non valido',
  },
  toasts: {
    success: 'Modifiche salvate!',
    description_generation_failed: 'Impossibile generare una descrizione. Riprova.',
  },
};
